
import './index.less'
import React from 'react'
const te = ['flex-start', 'center', 'flex-end']
console.log(React)
export default function ConversionOfficialCopy(props) {
  return (<div className={`conversionOfficial `}
    style={{
      width: 375,
      opacity: 0.5
    }}
  >
    <div className='conversionOfficial_seizeASeat' style={{
      paddingTop: props.ifon.ifon.paddingTop,
      paddingBottom: props.ifon.ifon.paddingBottom,
      paddingLeft: props.ifon.ifon.paddingLeft,
      paddingRight: props.ifon.ifon.paddingRight,
      justifyContent: te[props.ifon.ifon.layout]
    }}>
      <button className='seizeASeat_button' style={{
        fontSize: props.ifon.ifon.fontSize,
        color: props.ifon.ifon.color,
        backgroundColor: props.ifon.ifon.colorBack,
        width: props.ifon.ifon.width + '%',
        height: props.ifon.ifon.height,
        borderRadius: props.ifon.ifon.fillet
      }}>继续阅读下一章</button>
    </div>
  </div>)
}
